function Footer() {

    return (
        <div className={'footer_wrap'} >
            Copyright © 국가지점번호 센서관리 시스템. All Rights Reserved.
        </div>
    );
}

export default Footer;